import React from 'react';
import { Check, ExternalLink, Loader2, Trash2 } from 'lucide-react';

export default function CalendarConnectionCard({
  status,
  googleCalendars,
  selectedCalendarId,
  savingCalendar,
  busy,
  onConnect,
  onDisconnect,
  onCalendarSelect,
}) {
  return (
    <section className="border border-[#E3E2E0] rounded-xl p-5 bg-white">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col items-start gap-3">
          <h2 className="text-sm font-semibold text-[#191919]">Google Calendar</h2>
          {status?.connected ? (
            <button
              type="button"
              onClick={onDisconnect}
              disabled={busy}
              className="inline-flex items-center gap-2 rounded-lg border border-[#E3E2E0] px-3 py-2 text-sm text-[#191919] hover:bg-[#F7F7F5] disabled:opacity-50"
              data-testid="calendar-disconnect-btn"
            >
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Trash2 className="h-4 w-4" />}
              Disconnect
            </button>
          ) : (
            <button
              type="button"
              onClick={onConnect}
              disabled={busy || status?.configured === false}
              className="inline-flex items-center gap-2 rounded-lg bg-[#0A0A0A] px-3 py-2 text-sm text-white hover:bg-[#2D2D2D] disabled:cursor-not-allowed disabled:bg-[#9B9B9B]"
              data-testid="calendar-connect-btn"
            >
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ExternalLink className="h-4 w-4" />}
              {status?.needs_reconnect ? 'Reconnect Google' : 'Connect Google'}
            </button>
          )}
        </div>
        {status?.connected && (
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
          {status?.connected && googleCalendars.length > 0 && (
            <label className="flex items-center gap-2 text-xs text-[#6B6B6B]">
              Booking calendar
              <select
                value={selectedCalendarId}
                onChange={(e) => onCalendarSelect(e.target.value)}
                disabled={savingCalendar}
                className="min-w-[220px] rounded-lg border border-[#E3E2E0] bg-[#FBFBFA] px-3 py-2 text-sm text-[#191919] outline-none focus:ring-2 focus:ring-[#0A0A0A]"
                data-testid="google-calendar-select"
              >
                {googleCalendars.map((cal) => (
                  <option key={cal.id} value={cal.id}>
                    {cal.summary}{cal.primary ? ' (primary)' : ''}
                  </option>
                ))}
              </select>
            </label>
          )}
          {status?.connected && (
            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-medium bg-[#E6F4EA] text-[#1E7F4E]">
              {savingCalendar ? <Loader2 className="w-3 h-3 animate-spin" /> : <Check className="w-3 h-3" />}
              Connected
            </span>
          )}
          </div>
        )}
      </div>
    </section>
  );
}
